import React, { useEffect, useState } from 'react'

const slides = [
  {
    eyebrow: 'Technology that moves business forward',
    title: 'Build smarter. Grow faster.',
    description: 'Practical digital solutions that help ambitious teams work better and reach further.',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1800&q=85',
  },
  {
    eyebrow: 'Reliable digital experiences',
    title: 'Your ideas, made tangible.',
    description: 'From strategy to launch, we turn complex challenges into clear, useful products.',
    image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1800&q=85',
  },
  {
    eyebrow: 'A partner for your next chapter',
    title: 'Make technology feel simple.',
    description: 'Thoughtful design, dependable systems, and support that keeps your momentum going.',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1800&q=85',
  },
]

function Slider() {
  const [activeSlide, setActiveSlide] = useState(0)

  useEffect(() => {
    const interval = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length)
    }, 6000)

    return () => window.clearInterval(interval)
  }, [])

  const showSlide = (slideIndex) => {
    setActiveSlide((slideIndex + slides.length) % slides.length)
  }

  return (
    <section className="relative isolate overflow-hidden bg-[#071a3d]" aria-label="Featured services">
      <div className="relative mx-auto min-h-[360px] max-w-7xl sm:min-h-[410px] lg:min-h-[430px]">
        {slides.map((slide, slideIndex) => (
          <div
            key={slide.title}
            className={`absolute inset-0 transition-opacity duration-700 ${
              slideIndex === activeSlide ? 'z-10 opacity-100' : 'pointer-events-none opacity-0'
            }`}
            aria-hidden={slideIndex !== activeSlide}
          >
            <img
              src={slide.image}
              alt=""
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#071a3d] via-[#071a3d]/85 to-[#071a3d]/25" />
            <div className="relative flex min-h-[360px] items-center px-6 py-14 sm:min-h-[410px] sm:px-10 lg:min-h-[430px] lg:px-16">
              <div className="max-w-xl text-white">
                <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-cyan-300 sm:text-sm">
                  {slide.eyebrow}
                </p>
                <h1 className="max-w-lg text-4xl font-black leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                  {slide.title}
                </h1>
                <p className="mt-5 max-w-md text-sm leading-6 text-blue-100 sm:text-base">
                  {slide.description}
                </p>
                <a
                  href="/contact"
                  className="mt-7 inline-flex rounded-lg bg-cyan-400 px-5 py-3 text-sm font-bold text-[#071a3d] transition hover:-translate-y-0.5 hover:bg-cyan-300"
                >
                  Start a conversation
                </a>
              </div>
            </div>
          </div>
        ))}

        <div className="absolute bottom-6 left-6 z-20 flex items-center gap-2 sm:left-10 lg:left-16">
          {slides.map((slide, slideIndex) => (
            <button
              key={slide.title}
              type="button"
              onClick={() => showSlide(slideIndex)}
              className={`h-2 rounded-full transition-all ${
                slideIndex === activeSlide ? 'w-8 bg-cyan-300' : 'w-2 bg-white/50 hover:bg-white'
              }`}
              aria-label={`Show slide ${slideIndex + 1}`}
              aria-current={slideIndex === activeSlide ? 'true' : undefined}
            />
          ))}
          <span className="ml-2 text-xs font-semibold text-blue-100">0{activeSlide + 1} / 0{slides.length}</span>
        </div>

        <div className="absolute bottom-5 right-6 z-20 hidden gap-2 sm:flex lg:right-16">
          <button
            type="button"
            onClick={() => showSlide(activeSlide - 1)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 text-xl text-white transition hover:border-cyan-300 hover:bg-white/10"
            aria-label="Previous slide"
          >
            &#8592;
          </button>
          <button
            type="button"
            onClick={() => showSlide(activeSlide + 1)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 text-xl text-white transition hover:border-cyan-300 hover:bg-white/10"
            aria-label="Next slide"
          >
            &#8594;
          </button>
        </div>
      </div>
    </section>
  )
}

export default Slider
